import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getLiteral } from 'utils/getLiteral';
import Loading from 'components/Loading';
import ProviderInfo from '../ProviderInfo';
import ProviderDetail from '../ProviderDetail';
import Providers from '../Providers';
import NavigationTree from '../NavigationTree';
import DefaultProvider from '../DefaultProvider';
import CardManagerComponent from '../CardManager';
import ZendeskComponent from '../Zendesk';
import ZapierProvider from '../ZapierProvider';
import { SalesforceComponent } from '../Salesforce';
import MailchimpComponent from '../Mailchimp';
import SageComponent from '../Sage';
import SageX3Component from '../SageX3';
import VideoCallIntegrationComponent from '../VideoCallIntegrationComponent';
import Docusign from '../Docusign';
import Context from 'managers/Context';

import '../style.scss';

const VIDEO_CALLS_PROVIDER_ID = [27, 28];

const propTypes = {
    login: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
    return {
        login: state.config.login,
        implementation: state.config.userData.idImplementacion,
        email: state.config.userData.email,
        currency: state.config.userData.currencySymbol,
        iduser: state.config.userData.idUsuario,
        webTemplates: state.config.webTemplates.mnEmpresa,
        locale: state.config.userData.locale,
        language: state.config.userData.langISOInterface,
    };
}

class IntegrationsContainer extends Component {
    state = {
        provider: null,
        loading: true,
        error: false,
        data: [],
        isChecked: 1,
        notificationSend: false,
        videoCallIntegrations: [],
    };

    componentDidMount() {
        this.getIntegrations();
    }

    getIntegrations = () => {
        Context.settingsManager.getIntegrations(
            (success) => {
                // PM ask to filter integrations and not show here Signaturit and CardManager
                let result = success.filter((integration) => {
                    return integration.name !== 'Signaturit' && integration.name !== 'CardManager';
                });
                const videoCallIntegrations =
                    (result &&
                        result.filter((integration) =>
                            VIDEO_CALLS_PROVIDER_ID.includes(integration.id),
                        )) ||
                    [];
                this.setState({
                    idProvider: -1,
                    nameProvider: null,
                    loading: false,
                    error: false,
                    data: result,
                    videoCallIntegrations,
                });
            },
            (error) => {
                this.setState({
                    idProvider: -1,
                    nameProvider: null,
                    loading: false,
                    error: true,
                    data: [],
                    videoCallIntegrations: [],
                });
            },
        );
    };

    onResetClick = () => {
        this.setState({
            provider: null,
            loading: true,
            error: false,
            isChecked: 1,
            notificationSend: false,
        });
        this.getIntegrations();
    };

    providerDetail = (provider) => () => {
        this.setState({ provider });
    };

    renderProviders = () => {
        const { data } = this.state;
        let providers = data.map((provider, index, providers) => {
            let section = providers[index - 1] ? (
                providers[index - 1].data.SectionLabel === provider.data.SectionLabel ? null : (
                    <div className="section-integrations-label">
                        <span>{getLiteral(provider.data.SectionLabel)}</span>
                    </div>
                )
            ) : (
                <div className="section-integrations-label">
                    <span>{getLiteral(provider.data.SectionLabel)}</span>
                </div>
            );
            return (
                <div className="section-provider-container" key={index}>
                    {section}
                    <ProviderInfo
                        key={provider.id}
                        provider={provider}
                        onClick={this.providerDetail(provider)}
                    />
                </div>
            );
        });
        return <Providers providers={providers} />;
    };

    renderProviderDetail = (provider) => {
        const { implementation, email, iduser, webTemplates, locale, language } = this.props;
        let providerDetail;
        switch (provider.name) {
            case 'CardManager':
                providerDetail = (
                    <CardManagerComponent provider={provider} onResetClick={this.onResetClick} />
                );
                break;
            case 'Zendesk':
                providerDetail = (
                    <div className="detail-provider">
                        <div className="top-panel">
                            <NavigationTree provider={provider} onReset={this.onResetClick} />
                            <ProviderDetail provider={provider} />
                            <ZendeskComponent
                                provider={provider}
                                implementation={implementation}
                                iduser={iduser}
                                webTemplates={webTemplates}
                            />
                        </div>
                    </div>
                );
                break;
            case 'MailChimp':
                providerDetail = (
                    <div className="detail-provider">
                        <div className="top-panel">
                            <NavigationTree provider={provider} onReset={this.onResetClick} />
                            <ProviderDetail provider={provider} />
                            <MailchimpComponent
                                provider={provider}
                                implementation={implementation}
                                iduser={iduser}
                                webTemplates={webTemplates}
                                languageISO={language}
                            />
                        </div>
                    </div>
                );
                break;
            case provider.active ? 'Salesforce' : false:
                providerDetail = (
                    <div className="detail-provider">
                        <div className="top-panel">
                            <NavigationTree provider={provider} onReset={this.onResetClick} />
                            <ProviderDetail provider={provider} />
                            <SalesforceComponent
                                provider={provider}
                                implementation={implementation}
                                iduser={iduser}
                                locale={locale}
                            />
                        </div>
                    </div>
                );
                break;
            case 'Zapier':
                providerDetail = (
                    <ZapierProvider provider={provider} onResetClick={this.onResetClick} />
                );
                break;
            case 'SageLive':
                providerDetail = (
                    <SageComponent providerData={provider} onReset={this.onResetClick} />
                );
                break;
            case 'sagex3':
                providerDetail = (
                    <SageX3Component providerData={provider} onReset={this.onResetClick} />
                );
                break;
            case 'ZOOM':
            case 'zoom':
            case 'Zoom':
            case 'TEAMS':
            case 'teams':
            case 'Teams':
                providerDetail = (
                    <VideoCallIntegrationComponent
                        provider={provider}
                        onReset={this.onResetClick}
                        videoCallIntegrations={this.state.videoCallIntegrations}
                    />
                );
                break;
            case 'Docusign':
                providerDetail = <Docusign provider={provider} onResetClick={this.onResetClick} />;
                break;
            default:
                providerDetail = (
                    <DefaultProvider provider={provider} onResetClick={this.onResetClick} />
                );
                break;
        }
        return <div>{providerDetail}</div>;
    };

    renderError = () => {
        return (
            <div className="integrations">
                <div className="title-integrations">
                    <span>{getLiteral('title_integrations')}</span>
                </div>
                <div className="description-integrations">
                    <span>{getLiteral('error_unexpected')}</span>
                </div>
            </div>
        );
    };

    renderLoading = () => {
        return (
            <div className="integrations">
                <div className="title-integrations">
                    <span>{getLiteral('title_integrations')}</span>
                </div>
                <div className="description-integrations">
                    <Loading />
                </div>
            </div>
        );
    };

    render() {
        let { login } = this.props;
        let { provider, error, loading } = this.state;
        let renderContent = loading
            ? this.renderLoading()
            : error
              ? this.renderError()
              : !provider
                ? this.renderProviders()
                : this.renderProviderDetail(provider);
        return login && <div className="integrations-management">{renderContent}</div>;
    }
}

IntegrationsContainer.propTypes = propTypes;

export default connect(mapStateToProps)(IntegrationsContainer);
